"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS_OF_WEEK = void 0;
exports.DAYS_OF_WEEK = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
];
